<ng-container *ngIf="question$ | async as currentQuestion">
  <div [ngClass]="{'englishTestStyle': utilsService.feature === 'english-test', 'reasoningTestStyle': utilsService.feature === 'reasoning-test', 'digitalTestStyle': utilsService.feature === 'digital-test', 'adnTestStyle': utilsService.feature === 'adn-test'}">

    <!-- entra si no tiene que mostrar los textos legales -->
    <ng-container *ngIf="!showTerms">

      <!-- entra si el test esta pendiente o activo -->
      <ng-container *ngIf="currentQuestion?.testStatus === 'pending' || currentQuestion?.testStatus === 'active'">
        <!-- entra si el nivel no esta completo -->
        <ng-container *ngIf="!currentQuestion?.levelCompleted">
          <!-- entra para mostrar las instrucciones/ejemplos -->
          <ng-container *ngIf="!currentQuestion?.questions?.length">
            <!-- entra para el test de adn -->
            <ng-container *ngIf="(currentQuestion.testModelId == 1) || (currentQuestion.testModelId == 2)">
              <ct-adn-instruction [colors]="colors"></ct-adn-instruction>
            </ng-container>
            <!-- entra para el test de inglés -->
            <ng-container *ngIf="currentQuestion.testModelId == 24">
              <ct-english-instruction [colors]="colors"></ct-english-instruction>
            </ng-container>
            <!-- entra para el test de razonamiento -->
            <ng-container *ngIf="currentQuestion.testModelId == 25">
              <ct-reasoning-instruction *ngIf="currentQuestion.levels?.length" [colors]="colors"> </ct-reasoning-instruction>
              <ct-reasoning-example [colors]="colors" *ngIf="!currentQuestion.levels?.length && currentQuestion.nextLevel"></ct-reasoning-example>
            </ng-container>
            <ng-container *ngIf="currentQuestion.testModelId == 26">
              <ct-digital-instruction [colors]="colors"> </ct-digital-instruction>
            </ng-container>
          </ng-container>
          <!-- entra para mostrar las preguntas -->
          <ng-container *ngIf="currentQuestion?.questions?.length">
            <!-- entra para el test de adn -->
            <ng-container *ngIf="(currentQuestion.testModelId == 1) || (currentQuestion.testModelId == 2)">
              <ct-adn-question [colors]="colors"></ct-adn-question>
            </ng-container>
            <!-- entra para el test de inglés y razonamiento-->
            <ct-question *ngIf="currentQuestion?.testModelId === 24 || currentQuestion?.testModelId === 25"  [colors]="colors"></ct-question>
            <!-- entra para el test de conocimientos digitales -->
            <ct-digital-question *ngIf="currentQuestion?.testModelId == 26"></ct-digital-question>
          </ng-container>

        </ng-container>
        <!-- entra si el nivel esta completo -->
        <ng-container *ngIf="currentQuestion?.levelCompleted">
          <ct-level-completed [colors]="colors"></ct-level-completed>
        </ng-container>
      </ng-container>

      <!-- entra si el test esta completado -->
      <ng-container *ngIf="currentQuestion?.testStatus === 'completed'">
        <ng-container *ngIf="currentQuestion?.completedReason === 'levelTime'; else finalizedTemplate">
          <ct-ko-level-time [colors]="colors"></ct-ko-level-time>
        </ng-container>
        <ng-template #finalizedTemplate>
          <ct-finalized [colors]="colors"></ct-finalized>
        </ng-template>
      </ng-container>

      <!-- entra si el test esta expirado -->
      <ng-container *ngIf="currentQuestion?.testStatus === 'expired'">
        <!-- <p class="expiredText">{{'TEST.EXPIREDTEST'|translate}}</p> -->
         <ct-expired [colors]="colors"></ct-expired>
      </ng-container>

    </ng-container>

    <!-- entra si tiene que mostrar los textos legales -->
    <ng-container *ngIf="!currentQuestion?.questions?.length">
      <ct-legal-modal (acceptTerms)="postAcceptTerms()" [show]="showTerms" [clientId]="currentTest?.clientId"></ct-legal-modal>
    </ng-container>
  </div>
</ng-container>
